var img = {
  pistol: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/pistol.svg?4219"/>',
  silencer: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/silencer.svg?4219"/>',
  smg: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/smg.svg?4219"/>',
  shotgun: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/shotgun.svg?4219"/>',
  ak47: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/ak47.svg?4219"/>',
  sniper: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/sniper.svg?4219"/>',
  gernade: '<img src="https://cdn.shopify.com/s/files/1/0259/3869/0132/files/grenade.svg?4219"/>'
}

function reset(){
  $('.card').remove();
  
  var element;
  var rand;
  var amountOfCards = 210;
  
  for (var i = 0; i < amountOfCards; i++){
    
    rand = random(1,100);
    if (rand <= 65){
      element = '<div class="card glow-border" data-rarity="pistol" data-id="390128795732" id="itemNumber'+i+'">'+
                  	'<div class="feature-block-lootbox">'+
                    	'<div class="feature-block-icon-lootbox">'+img.pistol+'</div>'+
                        '<div class="feature-block-content-lootbox">'+
        					'<p>PISTOL</p>'+
        					'<p>Free Shipping</p>'+
        				'</div>'+
                    '</div>'+
                  '</div>';
      
      
      
    } else if (rand <= 75) {
    	element = '<div class="card glow-border" data-rarity="silencer" data-id="390128926804" id="itemNumber'+i+'">'+
                  	'<div class="feature-block-lootbox">'+
                    	'<div class="feature-block-icon-lootbox">'+img.silencer+'</div>'+
                        '<div class="feature-block-content-lootbox">'+
        					'<p>SILENCER</p>'+
        					'<p>10% Off</p>'+
        				'</div>'+
                    '</div>'+
                  '</div>';
    }
    else if (rand <= 85) {
    	element = '<div class="card glow-border" data-rarity="smg" data-id="390129647700" id="itemNumber'+i+'">'+
                  	'<div class="feature-block-lootbox">'+
                    	'<div class="feature-block-icon-lootbox">'+img.smg+'</div>'+
                        '<div class="feature-block-content-lootbox">'+
        					'<p>SMG</p>'+
        					'<p>10% Off On</p>'+
        					'<p>Second Blaster</p>'+
        				'</div>'+
                    '</div>'+
                  '</div>';
    }
    else if (rand <= 90) {
    	element = '<div class="card glow-border" data-rarity="shotgun" data-id="390129746004" id="itemNumber'+i+'">'+
                  	'<div class="feature-block-lootbox">'+
                    	'<div class="feature-block-icon-lootbox">'+img.shotgun+'</div>'+
                        '<div class="feature-block-content-lootbox">'+
        					'<p>SHOTGUN</p>'+
        					'<p>$10 Off</p>'+
        				'</div>'+
                    '</div>'+
                  '</div>';
    }
    else if (rand <= 95) {
    	element = '<div class="card glow-border" data-rarity="ak47" data-id="390129844308" id="itemNumber'+i+'">'+
                  	'<div class="feature-block-lootbox">'+
                    	'<div class="feature-block-icon-lootbox">'+img.ak47+'</div>'+
                        '<div class="feature-block-content-lootbox">'+
        					'<p>AK47</p>'+
        					'<p>Free Battle</p>'+
                            '<p>Pack With</p>'+
                            '<p>Blaster</p>'+
        				'</div>'+
                    '</div>'+
                  '</div>';
    }
    
    else if (rand <= 100) {
    	element = '<div class="card glow-border" data-rarity="sniper" data-id="390130401364" id="itemNumber'+i+'">'+
                  	'<div class="feature-block-lootbox">'+
                    	'<div class="feature-block-icon-lootbox">'+img.sniper+'</div>'+
                        '<div class="feature-block-content-lootbox">'+
        					'<p>SNIPER</p>'+
        					'<p>Free H/Phones</p>'+
        					'<p>With Blaster</p>'+
        				'</div>'+
                    '</div>'+
                  '</div>';
    }
    

    $('#cardList').append(element);
  }
  $('.card').first().css('margin-left', -778);
}
$('#loot-input-field').keyup(function () {
  let codeSnippet = $('#loot-input-field').val();
  for(let i=1; i<=10; i++){
    if(codeArray.includes(codeSnippet)){
      $('#gather-loot-button').removeAttr("disabled");
      $('#opening-loot').attr("src", "https://cdn2.shopify.com/s/files/1/0259/3869/0132/files/Loot-Crate---Animated4.gif?8322");
      $('#opening-loot').fadeTo(1);
    }
  }
});

function openCase(){
  if($('#gather-loot-button').is(":disabled")){
  } else{
    reset();
    var rand = random(1000,20000);
    var childNumber = Math.floor(rand/100)+1;
    var timings = ["easeInOutBack","easeOutExpo","easeInOutBounce","easeOutQuad","swing","easeOutElastic","easeInOutElastic"];
    var timing = timings[random(0,timings.length)];
    var reward = $('#itemNumber'+childNumber).attr('data-rarity');
    var rewardItemElement = $('#itemNumber'+childNumber);
    var container = $('.lootbox-container');
    var rewardItemElementMsg = $('#itemNumber'+childNumber+' .feature-block-content-lootbox');
	var rewardItemElementMsgHTML = $('#itemNumber'+childNumber+' .feature-block-content-lootbox').html();
	var lootMsgHead = $('.loot-msg-head');
    var lootMsgBody = $('.loot-msg-body');
    var splitRewardItemElementMsg = rewardItemElementMsgHTML.replace(/<p>/g, '').split('</p>');
	var rewardPrizeMsg;
    var rewardPrizeMsg2;
    var rewardPrizeMsg3;
    var rewardPrizeMsgDirections;
	var rewardWeaponMsg;
    var addItemToCart;
    
    rewardWeaponMsg = splitRewardItemElementMsg[0];
	// reward msg
    if (rewardWeaponMsg == 'PISTOL' || rewardWeaponMsg == 'SILENCER' || rewardWeaponMsg == 'SMG' || rewardWeaponMsg == 'SHOTGUN') {
    	rewardPrizeMsg = splitRewardItemElementMsg[1];
        rewardPrizeMsg2 = splitRewardItemElementMsg[2];

      	rewardPrizeMsgDirections = 'YOU HAVE RECEIVED '+rewardWeaponMsg+' ITEM!'+'<br>'+
                                   'COPY CODE INTO SHOPPING CART'+'<br>'+
                                   'FOR '+rewardPrizeMsg+' '+rewardPrizeMsg2;
    } else {
      if (rewardWeaponMsg == 'AK47') {
      		addItemToCart = 'BATTLE PACK';
      } else if (rewardWeaponMsg == 'SNIPER') {
      		addItemToCart = 'H/PHONES';
      }
    	rewardPrizeMsg = splitRewardItemElementMsg[1];
      	rewardPrizeMsg2 = splitRewardItemElementMsg[2];
        rewardPrizeMsg3 = splitRewardItemElementMsg[3];

        rewardPrizeMsgDirections = 'YOU HAVE RECEIVED '+rewardWeaponMsg+' ITEM!'+'<br>'+
                                   'COPY CODE INTO SHOPPING CART'+'<br>'+
                                   'FOR '+rewardPrizeMsg+' '+rewardPrizeMsg2+' '+rewardPrizeMsg3+'<br>'+
        						   'YOU MUST ADD '+addItemToCart+' TO YOUR CART';
    }
    // round down the width of each card, + 10 for margin, +6 for border, mutiply by number of childNumber (cards) and subtract offset (2 cards)
    $('.card').first().animate({
      marginLeft: -( (Math.floor(rewardItemElement.width()) + 16) * (childNumber - 2) )  
    }, 5000, timing, function(){

      var src = $('#itemNumber'+childNumber+' img').attr('src');
      
//       Disocount code id
      $.get("/admin/api/2019-07/price_rules/"+$('#itemNumber'+childNumber).data('id')+"/discount_codes.json", function(data, status){
        if(status == 'success'){
          document.cookie = "accessCode="+$('#loot-input-field').val();
          $('#loot-input-field').val(data.discount_codes[0].code);
          
          // add loot msg to .loot-msg-head and .loot-msg-body
          lootMsgHead.addClass("text-glow");
          var initialLootMsgHead = lootMsgHead.text().replace("ARKADE LOOT CRATE", "YOU WON!");
          lootMsgHead.text(initialLootMsgHead);
          lootMsgBody.html(rewardPrizeMsgDirections);
          
          $('#gather-loot-button').html('copy');
          $('#gather-loot-button').attr("onclick","copyDiscountcode()");
          var tomorrow = new Date();
          var timeInMill = 24*60*60*1000;
          var expDate = tomorrow.setTime(tomorrow.getTime() + timeInMill);
          var newDate = new Date(expDate);
          var expires = newDate.toUTCString();
          document.cookie = "discountCode="+data.discount_codes[0].code+'; expires='+expires;
        } else {
          alert('Sorry, something went wrong. Try again later.');
        }
      });
      
		
    });
  
  } 

}

function random(min, max){
  return Math.floor((Math.random()*(max - min))+min);
}

function copyDiscountcode(){
  var copyText = $('#loot-input-field');
  copyText.select();
  document.execCommand("copy");
  closeLoot();
}